module.exports = __webpack_public_path__ + "img/framework1_Image.ceb2e3aa.png";